import { render, staticRenderFns } from "./ListContentPage.vue?vue&type=template&id=3c8b2dfe"
import script from "./ListContentPage.vue?vue&type=script&lang=js"
export * from "./ListContentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports